import { MatchUpStatusEnum } from 'types/global'
import moment from 'moment'
import { AddressTypeEnum } from 'types/api/enums'

export const MIN_AGE_REFERENCE = 14
export const MIN_AGE_FOR_PSQ = 16
export const MAX_AGE_FOR_PSQ = 99
export const MIN_AGE_FOR_AVATAR_UPLOAD = 18
export const OPTED_OUT_PLAYER_NAME = 'UNKNOWN'
export const DEFAULT_TOURNAMENTS_LOADED = 5
export const MIN_GAMES_TO_WIN = 6
export const MIN_TBPOINTS_TO_WIN = 7
export const NO_SCORE_MATCHES = [MatchUpStatusEnum.BYE, MatchUpStatusEnum.WALKOVER]
export const CALENDAR_DATE_FORMAT = 'DD/MM/YY'
export const WTN_DATE_START = moment('01/01/16', 'DD/MM/YY').toISOString()
export const MILLISECONDS_SINCE_WTN_DATE_START =
  new Date().getTime() - new Date(WTN_DATE_START).getTime()
export const FIRST_TOURNAMENT_DATE_FALLBACK = WTN_DATE_START
export const RATING_HISTORY_START_DEFAULT = '2022-01-01'
export const SOCIAL_MATCHES_FETCH_LIMIT = 4

export const ADDRESS_PRIORITY_LOOKUP: Record<AddressTypeEnum, number> = {
  HOME: 1,
  RESIDENTIAL: 2,
  WORK: 3,
  MAIL: 4,
  VENUE: 5,
  UNKNOWN: 6,
}
